export const PayoutTypes = {
  TYPE: {
    STANDARD: 'standard',
    ADVANCED: 'advanced',
  },
  CREATE: {
    GROUP: 'group',
    SINGLE: 'single',
  },
  PAYOUT_TYPE: {
    STANDARD: 'STANDARD',
    AS: 'AS',
    ON_BEHALF_OF: 'ON_BEHALF_OF',
  },
};
